import { Injectable } from '@angular/core';
import { Logger } from 'projects/common/src/app/classes';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MiningToastService as ToastrService } from 'projects/common/src/app/services';
import { IResponseError } from 'projects/common/src/app/interfaces/communication/response';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { EToastPosition } from 'projects/common/src/app/enumerables/toast-position';

@Injectable({
  providedIn: 'root',
})
export class ErrorInterceptorService extends Logger implements HttpInterceptor {
  constructor(private toastrService: ToastrService, private langService: LanguageService) {
    super();
  }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          const data = err.error as IResponseError;
          this.error(err.message);
          if (err.status === 0 || err.status === 500) {
            const title = this.langService.message('communication error');
            const content = this.langService.message('failed connection to server, try again later');
            this.toastrService.error(title, content, {
              delay: 10000,
              position: EToastPosition.bottomRight,
            });
            this.error(err.message);
          }
          // Server error
          if (err.status === 400) {
            return throwError(data.error);
          }
          // Not found
          if (err.status === 404) {
            this.error(err.message);
          }
        }
        return throwError(err);
      }),
    );
  }
}
